import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Skeleton, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import DetailsCard from "./DetailsCard";
import PaymentList from "./PaymentList";
import AmountCard from "./AmountCard";
import { PaymentListProvider } from "../context/Listprovider";
import { PatientFullDetailsType } from "../../../../../PatientCare/PatientBooking/v2/types";
import moment from "moment";
import { getBilledDetailsForUser, patientientPaymentDetails } from "../../Service";
import { useMutation } from "react-query";
import { BilledDetails, BillResponseType, patientPayDetailsBIllsNoAndDates } from "../../type";
import { useParams } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useFetchPatientDetailsByEMR } from "../../../../../PatientCare/hookv2/apiHooks";

import { styled } from "@mui/material";
import usePopup from "@hooks/usePopup";

const StyledLeftField = styled("div")(() => ({
  "& .MuiOutlinedInput-root": {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    width: 180,
  },
}));

const StyledRightField = styled("div")(() => ({
  "& .MuiOutlinedInput-root": {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderLeft: 0,
    width: 140,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderLeft: 0,
  },
}));
const CashierPage = () => {
  const todayKey = moment().format("YYYY-MM-DD");
  const [billMap, setBillMap] = useState<Record<string, BillResponseType[]>>({});
  const [selectedDate, setSelectedDate] = useState<string>(todayKey);
  const [selectedBillNo, setSelectedBillNo] = useState<number | "ALL">("ALL");

  const mappedBills =
    selectedDate === "ALL"
      ? Object.values(billMap).flat()
      : billMap[selectedDate] ?? [];
  const activeBill = useMemo(() => {
    if (selectedBillNo === "ALL") return null;
    return mappedBills.find((b) => b.billNo === selectedBillNo) || null;
  }, [selectedBillNo, mappedBills]);
  const billedDates = Object.keys(billMap);
  const [billedDetails, setBilledDetails] = useState<BilledDetails[] | null>(null);
  const [patientDetails, setPatientDetails] = useState<patientPayDetailsBIllsNoAndDates | null>(null);
  const { mutate: getbillDetails } = useMutation(getBilledDetailsForUser, {
    onSuccess: (data) => {
      setBilledDetails(data.response?.billingDetails ?? null);

    },
  });
  console.log("dates", patientDetails?.dates)
  console.log("patientDetails", patientDetails)
  const { mutate: getPatientientPaymentDetails, isLoading: isPaymentLoading } = useMutation(
    patientientPaymentDetails,
    {
      onSuccess: (data) => {
        const responseData = data.response;
        if (!responseData) return;

        setPatientDetails(responseData);

        const grouped: Record<string, BillResponseType[]> = {};
        responseData.dates.forEach((dateGroup: any) => {
          grouped[dateGroup.date] = dateGroup.paydetails;
        });

        setBillMap(grouped);
        const todayStr = dayjs().format("YYYY-MM-DD");
        if (!grouped[selectedDate]) {
          if (grouped[todayStr]) {
            setSelectedDate(todayStr);
          } else {
            const firstAvailableDate = Object.keys(grouped)[0];
            if (firstAvailableDate) setSelectedDate(firstAvailableDate);
          }
        }
      }
    }
  );
  const { billingId } = useParams();
  console.log("billedDetails", billedDetails)
  console.log("patientDetails", patientDetails)


  const [patientData, setPatientData] =
    useState<PatientFullDetailsType | null>();

  const { mutate: getPatientData } = useFetchPatientDetailsByEMR({
    onSuccess: (result) => {
      setPatientData(result.response);

    },
  });
  const { encounterId } = useParams() as { encounterId: string };
  const queryParams = new URLSearchParams(location.search);
  console.log("encounterId", patientData?.pmaster.patientId)
  const patientId = patientData?.pmaster?.patientId;
  useEffect(() => {
    const emrNo = (queryParams.get("emrno") || "") as string;
    getPatientData({ emrNo, encounterId: parseInt(encounterId || "0") });

    if (patientId) {
      getPatientientPaymentDetails(patientId);
    }
  }, [billingId, getbillDetails, patientId]);


  const [paymentTypeMode, setPaymentTypeMode] = useState<"full" | "partial">("partial");

  const amountToDisplay = (() => {
    if (!patientDetails) return 0;

    if (paymentTypeMode === "full") {
      return Number(patientDetails.grantTotalPatShare.toFixed(2)) || 0;
    }

    if (activeBill) {
      return Number(activeBill.balanceAmount.toFixed(2)) || 0;
    }

    if (selectedDate !== "ALL") {
      const dateObj = patientDetails.dates.find((d) => d.date === selectedDate);
      return Number(dateObj?.patientShareAmount.toFixed(2)) || 0;
    }

    return patientDetails.grantTotalPatShare.toFixed(2) || 0;
  })();

  const billsToSend =
    paymentTypeMode === "full"
      ? Object.values(billMap).flat()
      : activeBill
        ? [activeBill]
        : mappedBills;


  const hasBills =
    patientDetails?.dates &&
    patientDetails.dates.some(date => date.paydetails?.length > 0);
  const isAutoFullPayment =
    paymentTypeMode === "full" ||
    (paymentTypeMode === "partial" && selectedBillNo === "ALL")
  useEffect(() => {
    const unpaidBills = mappedBills.filter(b => Number(b.balanceAmount) > 0);
    
    if (selectedBillNo !== "ALL") {
      const exists = mappedBills.some(b => b.billNo === selectedBillNo);
      if (!exists) {
        if (unpaidBills.length === 1) {

          setSelectedBillNo(unpaidBills[0].billNo);
        } else {
          setSelectedBillNo("ALL");
        }
      }
    } else {
      if (unpaidBills.length === 1) {
        setSelectedBillNo(unpaidBills[0].billNo);
      }
    }
  }, [mappedBills, selectedBillNo]);

  const [paymentListLength, setPaymentListLength] = useState(0);
  const { showSnackbar } = usePopup()
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <PaymentListProvider>
        <div className="pt-3 px-2 pb-2 flex flex-col gap-y-1">

          <DetailsCard />
          {isPaymentLoading ? (
            <>
              <Skeleton variant="rectangular" height={100} />
              <Skeleton variant="rectangular" height={100} />
            </>
          ) : (
            patientDetails ? (
              hasBills ? (
                <>
                  <Paper
                    elevation={4}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      px: 2,
                      py: 1,
                      m: 0,
                      height: "100%"
                    }}
                  >
                    <Box >
                      <Tabs
                        value={paymentTypeMode}
                        onChange={(_e, value) => {
                          if (paymentListLength > 0) {
                            showSnackbar({
                              message: "Please complete or clear the payment transaction before switching modes.",
                              open: true,
                              variant: "warning",
                              duration: 3000,
                            });
                            return;
                          }

                          setPaymentTypeMode(value);
                          if (value === "full") {
                            setSelectedBillNo("ALL");
                          }
                        }}
                      >
                        <Tab label="Full Payment" value="full" />
                        <Tab label="Partial Payment" value="partial" />
                      </Tabs>
                    </Box>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 10,
                      width: "100%",
                    }}>

                      <div style={{ fontWeight: 600, margin: "10px 0" }}>
                        Total Bill Amount Due :{" "}
                        {amountToDisplay}
                      </div>
                      {paymentTypeMode === "partial" && (
                        <div style={{ display: "flex" }}>
                          <StyledLeftField>
                            <FormControl size="small">
                              <InputLabel>Select Date Wise Bills</InputLabel>
                              <Select
                                value={selectedDate}
                                label="Select Date Wise Bills"
                                onChange={(e) => {
                                  setSelectedDate(e.target.value);
                                }}
                              >
                                {billedDates.map((date) => {
                                  // 1. Check if every bill on this specific date is paid
                                  const billsForDate = billMap[date] || [];
                                  const isDateFullyPaid = billsForDate.length > 0 &&
                                    billsForDate.every((bill) => Number(bill.balanceAmount) <= 0);

                                  return (
                                    <MenuItem
                                      key={date}
                                      value={date}
                                      // 2. Disable if all bills for this date are paid
                                      disabled={isDateFullyPaid}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        opacity: isDateFullyPaid ? 0.6 : 1
                                      }}
                                    >
                                      <span>{dayjs(date).format("DD MMMM YYYY")}</span>

                                      {isDateFullyPaid && (
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            ml: 2,
                                            color: "success.main",
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase'
                                          }}
                                        >
                                          (Paid)
                                        </Typography>
                                      )}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </StyledLeftField>
                          <StyledRightField>
                            <FormControl size="small">
                              <InputLabel>Select Bill</InputLabel>
                              <Select
                                value={selectedBillNo}
                                label="Select Bill"
                                onChange={(e) => setSelectedBillNo(e.target.value as number | "ALL")}
                              >
                                <MenuItem value="ALL">All Bills</MenuItem>

                                {mappedBills.map((bill) => {
                                  // Determine if the bill is fully paid
                                  const isPaid = Number(bill.balanceAmount) <= 0;

                                  return (
                                    <MenuItem
                                      key={bill.billNo}
                                      value={bill.billNo}
                                      // 1. This prevents the user from selecting it
                                      disabled={isPaid}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        // Optional: change look of disabled item
                                        opacity: isPaid ? 0.6 : 1
                                      }}
                                    >
                                      <span>Bill No - {bill.billNo}</span>
                                      {isPaid && (
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            ml: 2,
                                            color: "success.main",
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase'
                                          }}
                                        >
                                          (Paid)
                                        </Typography>
                                      )}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </StyledRightField>
                        </div>

                      )}
                    </div>

                  </Paper>


                  <div className="mt-2">

                    <AmountCard selectedBill={billsToSend} paymentTypeMode={paymentTypeMode} />
                  </div>

                  <div className="mt-2">

                    <PaymentList isAutoFullPayment={isAutoFullPayment} onListChange={(len) => setPaymentListLength(len)} selectedBillNo={selectedBillNo} onPaymentSuccess={() => {
      if (patientId) {
        getPatientientPaymentDetails(patientId);
      }
    }} />

                  </div>

                </>

              ) : (
                <Paper sx={{ mt: 2, p: 4, textAlign: "center" }}>
                  <Typography variant="h6" color="text">
                    No Bills to Pay
                  </Typography>
                </Paper>
              )

            ) : null
          )}
        </div>
      </PaymentListProvider>
    </LocalizationProvider>
  );
};

export default CashierPage;
